export default __webpack_public_path__ + "static/media/pdv-1366x667.bacafc97.jpg";